import React, { useState, useEffect } from 'react';
import '../App.css';
import Swal from 'sweetalert2';
import { useAuth } from '../context/AuthContext';
import './SupervisorDetailModal.css'; // Import the new CSS file

function SupervisorDetailModal({ isOpen, onClose, supervisor, onUpdateSupervisor, onDeleteSupervisor, isEditMode }) {
  const [editedSupervisor, setEditedSupervisor] = useState(supervisor);
  const { user } = useAuth();

  useEffect(() => {
    setEditedSupervisor(supervisor);
  }, [supervisor]);

  if (!isOpen) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setEditedSupervisor({ ...editedSupervisor, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // 필수 필드(id, email, notes 제외)가 채워졌는지 확인
    for (const key in editedSupervisor) {
      if (key !== 'id' && key !== 'email' && key !== 'notes' && editedSupervisor[key].trim() === '') {
        Swal.fire({
          icon: 'warning',
          title: '입력 오류',
          text: '이름, 직위, 생년월일, 연락처는 필수 항목입니다.',
        });
        return;
      }
    }
    onUpdateSupervisor(editedSupervisor);
  };

  const handleDelete = async () => {
    const result = await Swal.fire({
      title: '정말로 이 감리원을 삭제하시겠습니까?',
      text: "이 감리원을 삭제하면 되돌릴 수 없습니다!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '예, 삭제합니다!',
      cancelButtonText: '취소',
    });

    if (result.isConfirmed) {
      onDeleteSupervisor(supervisor.id);
      onClose(); // 삭제 후 모달 닫기
    }
  };

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <button onClick={onClose} className="modal-close-button">×</button>
        <h1>{isEditMode ? '감리원 정보 수정' : '감리원 상세 정보'}</h1>
        <hr/><br/>
        <form onSubmit={isEditMode ? handleSubmit : (e) => e.preventDefault()}>
          <div className="form-grid">
            <div className="form-group">
              <label>이름</label>
              <input type="text" name="name" value={editedSupervisor.name} onChange={handleInputChange} readOnly={!isEditMode} />
            </div>
            <div className="form-group">
              <label>직위</label>
              <input type="text" name="position" value={editedSupervisor.position} onChange={handleInputChange} readOnly={!isEditMode} />
            </div>
            <div className="form-group">
              <label>생년월일</label>
              <input type="text" name="birthDate" value={editedSupervisor.birthDate} onChange={handleInputChange} readOnly={!isEditMode} placeholder="YYYY-MM-DD" />
            </div>
            <div className="form-group">
              <label>연락처</label>
              <input type="text" name="phone" value={editedSupervisor.phone} onChange={handleInputChange} readOnly={!isEditMode} />
            </div>
            <div className="form-group">
              <label>이메일</label>
              <input type="email" name="email" value={editedSupervisor.email || ''} onChange={handleInputChange} readOnly={!isEditMode} />
            </div>
          </div>
          <div className="form-group">
            <label>비고</label>
            <textarea name="notes" value={editedSupervisor.notes || ''} onChange={handleInputChange} readOnly={!isEditMode} style={{ width: '100%', minHeight: '100px' }}></textarea>
          </div>
          {user && user.role === 'ADMIN' && isEditMode && (
            <div className="form-actions supervisor-detail-actions-container"> {/* New container for buttons */}
              <button type="submit" className="supervisor-detail-edit-button">수정하기</button>
              <button type="button" onClick={handleDelete} className="supervisor-detail-delete-button">삭제하기</button>
            </div>
          )}
        </form>
      </div>
    </div>
  );
}

export default SupervisorDetailModal;